import "jquery";
import * as ko from "knockout";
import {BaseCropComponent} from "./BaseCropComponent";
import {Crop } from "../Models/Crops/Crop";

export class Crops extends BaseCropComponent<Crop> {
    constructor() {
        super($('#crops-table'));
    }
    init(): void {
        this.cropsApi.getCrops().then((res) => {
            super.init(res);
        });
    }
}